import { LogLevel } from "@azure/msal-browser";

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_AUTH_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AUTH_TENANT_ID}`,
    redirectUri: process.env.REACT_APP_AUTH_REDIRECT_URL,
  },
  cache: {
    cacheLocation: "localStorage",
    // storeAuthStateInCookie: true, // only if you need legacy browser support
  },
  system: {
    loggerOptions: {
      logLevel: LogLevel.Trace,
      piiLoggingEnabled: false,
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        console.debug(`[MSAL:${LogLevel[level]}] ${message}`);
      },
    },
  },
};

export const loginRequest = {
  scopes: ["User.Read"],
};

export const protectedResources = {
  appServiceApi: {
    scopes: [process.env.REACT_APP_AUTH_API_TOKEN_SCOPE],
  },
};
